export default {
  methods: {
    getBandNotifNumber: function () {
      return this.$axios.$get("/notification/notification/band-meta/")
    },
    bandHasNotif: async function (id) {
      const notifArr = await this.getBandNotifNumber()

      return Object.entries(notifArr).some(([key, value]) => {
        return window.parseInt(key) === id
      })
    },
  },
}
